import type { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { api } from "@/api/apiSlice";
import { backendBase } from "@/api/backendBase";
import { OrderTags } from "./OrderTags";
import type { OrderDto } from "@/api/dtos";
import type { Order } from "./_models/Order";
import { toOrderFromOrderDto } from "./_transformers/toOrderFromOrderDto";

/** One order (GET /orders/{orderId}), shaped like a getOrderList entry; a missing order is the backend's 404 as the query's error. */
export const getOrderByIdApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getOrderById: builder.query<Order, string>({
      queryFn: async (orderId) => {
        try {
          const res = await axios.get<OrderDto>(
            `${backendBase()}/orders/${encodeURIComponent(orderId)}`,
            { headers: { Accept: "application/json" } },
          );
          const order = toOrderFromOrderDto(res.data);
          return { data: order };
        }
        catch (e) {
          if (axios.isAxiosError(e) && e.response) {
            return {
              error: { status: e.response.status, data: e.response.data } as FetchBaseQueryError,
            };
          }
          return {
            error: { status: "FETCH_ERROR", error: String(e) } as FetchBaseQueryError,
          };
        }
      },
      providesTags: (_result, _error, orderId) => [{ type: OrderTags.Order, id: orderId }],
    }),
  }),
});

export const getOrderById = getOrderByIdApi.endpoints.getOrderById;
